import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-circle-radio-btn',
  templateUrl: './circle-radio-btn.component.html',
  styleUrls: ['./circle-radio-btn.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class CircleRadioBtnComponent {
  @Input() disabled = false;
  @Input() name = '';
  @Input() modelValue!: boolean;
  @Input() value!: boolean;
  @Input() dataTestId = '';
  constructor() {}
  get checked(): boolean {
    return this.modelValue === this.value;
  }

  @Output() modelValueChange = new EventEmitter<boolean>();

  onChange(): void {
    this.modelValueChange.emit(this.value);
  }
}
